import { nanoid } from '@reduxjs/toolkit'

import { getLastFieldRow, getLastGroupFieldRow, adjustPositions } from './order'

export function isGroup(id) {
  return isNaN(+id)
}

export function getGroupedFields(fields) {
  if (!fields) return []

  const { ids, entities } = fields

  return ids.reduce((groupedFields, id) => {
    if (isGroup(id)) {
      groupedFields.push({
        id,
        isGroup: true,
        children: entities[id].children
          .map(({ id }) => ({ id, isGroup: false, children: [] }))
          .sort((a, b) => entities[a.id].fieldRow - entities[b.id].fieldRow)
      })
    }

    if (entities[id].fieldGroup === null) {
      groupedFields.push({ id, isGroup: false, children: [] })
    }

    return groupedFields
  }, [])
}

export function getGroups(fields) {
  const groups = new Map()

  fields.forEach((field) => {
    if (field.fieldGroup !== null) {
      if (!groups.has(field.fieldGroup)) {
        groups.set(field.fieldGroup, {
          id: nanoid(),
          fieldName: field.fieldGroup,
          fieldGroup: field.fieldGroup,
          groupType: field.groupType,
          internalTypeName: 'group',
          fieldProperties: {},
          fieldRow: null,
          active: true,
          isGroup: true,
          unsaved: false,
          children: []
        })
      }

      groups.get(field.fieldGroup).children.push({ id: field.id, fieldRow: field.fieldRow })
    }
  })

  return Array.from(groups.values())
}

export function changeFieldGroup(fields, { fieldId, currentGroupId, targetGroupId }) {
  const { fieldRow: sourceFieldRow } = fields.entities[fieldId]

  let targetFieldRow = getLastGroupFieldRow(fields, targetGroupId)

  const reorderedFields = adjustPositions({ fields, sourceFieldRow, targetFieldRow, isGroupOperation: true })

  let targetGroupChildrens = fields.entities[targetGroupId]?.children
  targetGroupChildrens = [...targetGroupChildrens, { id: fieldId, fieldRow: targetFieldRow }]

  let currentGroupChildrens = fields.entities[currentGroupId]?.children
  currentGroupChildrens = currentGroupChildrens.filter(({ id }) => id !== fieldId)

  const updates = [
    { id: targetGroupId, children: targetGroupChildrens },
    { id: currentGroupId, children: currentGroupChildrens },
    {
      id: fieldId,
      fieldGroup: fields.entities[targetGroupId].fieldGroup,
      groupType: fields.entities[targetGroupId].groupType
    },
    ...reorderedFields
  ]

  return updates
}

export function addFieldToGroup(fields, { fieldId, targetGroupId }) {
  const { fieldRow: sourceFieldRow } = fields.entities[fieldId]

  let targetFieldRow = getLastGroupFieldRow(fields, targetGroupId)

  const reorderedFields = adjustPositions({ fields, sourceFieldRow, targetFieldRow, isGroupOperation: true })

  let targetGroupChildrens = fields.entities[targetGroupId].children
  targetGroupChildrens = [...targetGroupChildrens, { id: fieldId, fieldRow: targetFieldRow }]

  const updates = [
    { id: targetGroupId, children: targetGroupChildrens },
    {
      id: fieldId,
      fieldGroup: fields.entities[targetGroupId].fieldGroup,
      groupType: fields.entities[targetGroupId].groupType
    },
    ...reorderedFields
  ]

  return updates
}

export function excludeFieldFromGroup(fields, { fieldId, currentGroupId }) {
  const { fieldRow: sourceFieldRow } = fields.entities[fieldId]

  const targetFieldRow = getLastFieldRow(fields)

  const reorderedFields = adjustPositions({ fields, sourceFieldRow, targetFieldRow, isGroupOperation: true })

  let currentGroupChildrens = fields.entities[currentGroupId]?.children
  currentGroupChildrens = currentGroupChildrens.filter(({ id }) => id !== fieldId)

  const updates = [
    { id: currentGroupId, children: currentGroupChildrens },
    { id: fieldId, fieldGroup: null, groupType: null },
    ...reorderedFields
  ]

  return updates
}
